
export { legacyApiAuth } from "/builds/t2_e_sw-P/2/dd3tech/wiggot/wiggot-web/packages/apis/legacies-api/legacy-api.ts"
export { monopolioApi } from "/builds/t2_e_sw-P/2/dd3tech/wiggot/wiggot-web/packages/apis/legacies-api/legacy-api.ts"
export { wiggotAPI } from "/builds/t2_e_sw-P/2/dd3tech/wiggot/wiggot-web/packages/apis/legacies-api/wiggot-api.ts"